import React from 'react'
import { Maybe } from '@graphql-tools/utils'
import { InternalLink } from '@/atoms/InternalLink'
import { AngelLogo } from '@/atoms/Logos/AngelLogo'
import { paths } from '@/constants/paths'
import { LoginOrigin } from '@/views/GuildSignupView/GuildEmailInput/GuildEmailInput'
import { SignupCreateAccountEmail } from '@/views/SignupCreateAccountView/SignupCreateAccountEmail'
import { SignUpAuthForm } from '../GuildSignUpAuthView/SignUpAuthForm'

interface GuildSignUpCreateAccountViewProps {
  userEmail: string
  offerId?: string
  loginStartedOrigin: Maybe<LoginOrigin>
  loginRedirectUrl: Maybe<string>
}

export const GuildSignUpCreateAccountView: React.FC<GuildSignUpCreateAccountViewProps> = ({
  userEmail,
  offerId,
  loginStartedOrigin,
  loginRedirectUrl,
}) => {
  const [email, setEmail] = React.useState(userEmail)
  const showEmailStep = !email

  return (
    <main className="relative flex min-h-screen items-start justify-center bg-core-gray-100 lg:items-center">
      <div className="absolute left-0 top-0 hidden py-3 sm:mx-6 sm:py-4 md:flex md:justify-start">
        <InternalLink aria-label="Angel" href={paths.home}>
          <AngelLogo height={40} color="black" />
        </InternalLink>
      </div>
      {showEmailStep ? (
        <SignupCreateAccountEmail
          onEmailSubmit={setEmail}
          loginStartedOrigin={loginStartedOrigin}
          loginRedirectUrl={loginRedirectUrl}
        />
      ) : (
        <SignUpAuthForm
          step="create-account"
          userEmail={email}
          offerId={offerId}
          loginStartedOrigin={loginStartedOrigin}
          loginRedirectUrl={loginRedirectUrl}
        />
      )}
    </main>
  )
}
